var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _rect2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect3, _rect4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoomNotReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 109,
    viewBox: "30 -30 156 159",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2971 59.9949C84.3519 60.9401 84.3782 66.9526 84.5095 69.8407L172.728 70.6283C172.597 67.4777 172.098 60.94 171.153 59.9948C170.208 59.0496 167.083 59.0759 165.639 59.2072C139.252 59.076 86.2423 59.0497 85.2971 59.9949Z",
    fill: "var(--warning-background-color, #ffefc1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.448 23.1547C88.448 19.7925 91.1736 17.0669 94.5358 17.0669H163.49C166.852 17.0669 169.578 19.7925 169.578 23.1547V58.8133H88.448V23.1547Z",
    fill: "var(--warning-background-color, #ffefc1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.562 33.3457V59.9951",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.323 18.1177H147.523",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9249 59.9953V21.9247C89.9249 20.915 90.3295 19.9467 91.0496 19.2327C91.7697 18.5188 92.7464 18.1177 93.7648 18.1177H105.284",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.402 71.416H130.243H86.0848",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.284 48.5742H155.203C157.239 48.5742 159.193 49.3764 160.633 50.8043C162.073 52.2323 162.882 54.1689 162.882 56.1883V59.9954H97.6044V56.1883C97.6044 54.1689 98.4135 52.2323 99.8537 50.8043C101.294 49.3764 103.247 48.5742 105.284 48.5742Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0848 82.8375V63.8022C86.0848 62.7925 86.4894 61.8241 87.2095 61.1102C87.9296 60.3962 88.9063 59.9951 89.9247 59.9951H170.562C171.581 59.9951 172.557 60.3962 173.277 61.1102C173.997 61.8241 174.402 62.7925 174.402 63.8022V82.8375",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 40.4424C124.483 40.0359 124.351 39.6403 124.107 39.3135C123.863 38.9867 123.52 38.7459 123.128 38.6264C117.804 36.7 111.964 36.7 106.64 38.6264C106.248 38.7459 105.905 38.9867 105.661 39.3135C105.417 39.6403 105.285 40.0359 105.284 40.4424V48.5743H124.484V40.4424Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.203 40.4424C155.202 40.0359 155.07 39.6403 154.826 39.3135C154.582 38.9867 154.239 38.7459 153.847 38.6264C148.523 36.7 142.683 36.7 137.359 38.6264C136.967 38.7459 136.624 38.9867 136.38 39.3135C136.136 39.6403 136.004 40.0359 136.003 40.4424V48.5743H155.203V40.4424Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.444 18.1174V10.5033C101.444 8.48389 102.254 6.54721 103.694 5.11928C105.134 3.69136 107.087 2.88916 109.124 2.88916C111.161 2.88916 113.114 3.69136 114.555 5.11928C115.995 6.54721 116.804 8.48389 116.804 10.5033V14.3103",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.203 24.2655C122.246 24.4402 122.248 24.6225 122.209 24.7981C122.17 24.9738 122.09 25.1381 121.976 25.2782C121.864 25.4205 121.719 25.5354 121.555 25.6139C121.391 25.6925 121.21 25.7326 121.028 25.7312H113.479C113.19 25.7312 112.904 25.6665 112.644 25.5419C112.384 25.4173 112.155 25.2361 111.975 25.0118C111.796 24.7874 111.669 24.5258 111.606 24.2463C111.542 23.9667 111.543 23.6766 111.609 23.3975C113.087 17.0473 113.348 14.3101 116.804 14.3101C120.402 14.3101 120.54 17.2986 122.203 24.2655Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.683 18.1174V10.5033C143.683 8.48389 144.492 6.54721 145.932 5.11928C147.373 3.69136 149.326 2.88916 151.363 2.88916C153.4 2.88916 155.353 3.69136 156.793 5.11928C158.233 6.54721 159.043 8.48389 159.043 10.5033V14.3103",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.442 24.2655C164.485 24.4402 164.487 24.6225 164.448 24.7981C164.409 24.9738 164.329 25.1381 164.215 25.2782C164.102 25.4205 163.958 25.5354 163.794 25.6139C163.63 25.6925 163.449 25.7326 163.267 25.7312H155.717C155.428 25.7312 155.143 25.6665 154.883 25.5419C154.623 25.4173 154.394 25.2361 154.214 25.0118C154.035 24.7874 153.908 24.5258 153.845 24.2463C153.781 23.9667 153.782 23.6766 153.847 23.3975C155.326 17.0473 155.587 14.3101 159.043 14.3101C162.641 14.3101 162.779 17.2986 164.442 24.2655Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.1489,
    y: 78.7515,
    width: 115.839,
    height: 10.9499,
    rx: 5.47497,
    fill: "var(--primary-text-color, #313639)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 32.5581V59.2075",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.748 17.3296H145.947",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3492 59.2072V21.1366C88.3492 20.127 88.7538 19.1586 89.4739 18.4447C90.194 17.7307 91.1707 17.3296 92.1891 17.3296H103.709",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.827 70.6284H128.668H84.5094",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.709 47.7861H153.627C155.664 47.7861 157.617 48.5883 159.057 50.0163C160.498 51.4442 161.307 53.3809 161.307 55.4002V59.2073H96.0289V55.4002C96.0289 53.3809 96.838 51.4442 98.2783 50.0163C99.7185 48.5883 101.672 47.7861 103.709 47.7861V47.7861Z",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5094 82.0499V63.0146C84.5094 62.0049 84.914 61.0365 85.6341 60.3226C86.3542 59.6086 87.3309 59.2075 88.3493 59.2075H168.987C170.005 59.2075 170.982 59.6086 171.702 60.3226C172.422 61.0365 172.827 62.0049 172.827 63.0146V82.0499",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.908 39.6543C122.907 39.2478 122.775 38.8522 122.531 38.5254C122.287 38.1986 121.944 37.9579 121.553 37.8383C116.228 35.912 110.389 35.912 105.064 37.8383C104.672 37.9579 104.329 38.1986 104.085 38.5254C103.841 38.8522 103.709 39.2478 103.709 39.6543V47.7862H122.908V39.6543Z",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.627 39.6543C153.626 39.2478 153.494 38.8522 153.25 38.5254C153.007 38.1986 152.664 37.9579 152.272 37.8383C146.947 35.912 141.108 35.912 135.783 37.8383C135.391 37.9579 135.048 38.1986 134.804 38.5254C134.56 38.8522 134.428 39.2478 134.428 39.6543V47.7862H153.627V39.6543Z",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.869 17.3298V9.71568C99.869 7.69629 100.678 5.75961 102.118 4.33168C103.559 2.90376 105.512 2.10156 107.549 2.10156C109.586 2.10156 111.539 2.90376 112.979 4.33168C114.419 5.75961 115.229 7.69629 115.229 9.71568V13.5227",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.627 23.4779C120.67 23.6526 120.673 23.8349 120.633 24.0105C120.594 24.1862 120.514 24.3505 120.4 24.4906C120.288 24.6329 120.144 24.7478 119.979 24.8263C119.815 24.9049 119.635 24.945 119.452 24.9436H111.903C111.614 24.9436 111.329 24.8789 111.068 24.7543C110.808 24.6297 110.58 24.4485 110.4 24.2242C110.22 23.9998 110.094 23.7382 110.03 23.4587C109.967 23.1791 109.968 22.889 110.033 22.6099C111.511 16.2597 111.772 13.5225 115.228 13.5225C118.826 13.5225 118.964 16.511 120.627 23.4779Z",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.107 17.3298V9.71568C142.107 7.69629 142.917 5.75961 144.357 4.33168C145.797 2.90376 147.75 2.10156 149.787 2.10156C151.824 2.10156 153.777 2.90376 155.218 4.33168C156.658 5.75961 157.467 7.69629 157.467 9.71568V13.5227",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.866 23.4779C162.909 23.6526 162.911 23.8349 162.872 24.0105C162.833 24.1862 162.753 24.3505 162.639 24.4906C162.527 24.6329 162.383 24.7478 162.218 24.8263C162.054 24.9049 161.873 24.945 161.691 24.9436H154.142C153.853 24.9436 153.567 24.8789 153.307 24.7543C153.047 24.6297 152.818 24.4485 152.639 24.2242C152.459 23.9998 152.332 23.7382 152.269 23.4587C152.205 23.1791 152.206 22.889 152.272 22.6099C153.75 16.2597 154.011 13.5225 157.467 13.5225C161.065 13.5225 161.203 16.511 162.866 23.4779Z",
    stroke: "var(--warning-color, #FFC107)",
    strokeWidth: 3.04388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1407,
    cy: 52.6497,
    r: 49.9178,
    fill: "var(--warning-background-color, #ffefc1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0083,
    y: 94.4946,
    width: 47.3033,
    height: 14,
    rx: 7,
    fill: "var(--primary-text-color, #313639)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4204 52.6498C93.4204 76.5525 74.0434 95.9295 50.1407 95.9295C26.2379 95.9295 6.86096 76.5525 6.86096 52.6498C6.86096 28.7471 26.2379 9.37012 50.1407 9.37012C74.0434 9.37012 93.4204 28.7471 93.4204 52.6498Z",
    fill: "var(--warning-color, #FFC107)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6675 30.1373C73.6868 26.6597 78.4964 34.5274 78.96 36.1169",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8474 57.6213C58.6131 56.8355 55.9449 59.1114 55.7017 59.714",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1426 24.6705C37.1232 21.1929 32.3136 29.0606 31.85 30.6501",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3781 39.7256C41.5454 39.7256 41.7088 39.7752 41.8479 39.8681C41.9869 39.961 42.0953 40.093 42.1593 40.2475C42.2233 40.402 42.24 40.5721 42.2074 40.7361C42.1748 40.9001 42.0943 41.0508 41.976 41.169C41.8578 41.2873 41.7071 41.3678 41.5431 41.4004C41.3791 41.433 41.2091 41.4163 41.0546 41.3523C40.9001 41.2883 40.768 41.1799 40.6751 41.0409C40.5822 40.9018 40.5326 40.7384 40.5326 40.5711C40.5326 40.3469 40.6217 40.1318 40.7802 39.9732C40.9388 39.8147 41.1539 39.7256 41.3781 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.149 39.7256C70.3162 39.7256 70.4797 39.7752 70.6188 39.8681C70.7578 39.961 70.8662 40.093 70.9302 40.2475C70.9942 40.402 71.0109 40.5721 70.9783 40.7361C70.9457 40.9001 70.8651 41.0508 70.7469 41.169C70.6286 41.2873 70.478 41.3678 70.314 41.4004C70.1499 41.433 69.9799 41.4163 69.8254 41.3523C69.6709 41.2883 69.5389 41.1799 69.446 41.0409C69.3531 40.9018 69.3035 40.7384 69.3035 40.5711C69.3035 40.3469 69.3925 40.1318 69.5511 39.9732C69.7097 39.8147 69.9248 39.7256 70.149 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3371 79.5401L54.8901 73.6855L60.4019 72.8597C60.9447 72.8296 61.4532 72.5852 61.8157 72.1802C62.1782 71.7752 62.365 71.2427 62.3349 70.7C62.3048 70.1573 62.0604 69.6488 61.6554 69.2863C61.2504 68.9238 60.7179 68.737 60.1752 68.7671L44.3359 69.2836C44.3359 69.2836 45.1604 60.7907 42.3944 60.7907C39.6283 60.7906 39.6542 63.9381 38.5841 69.36L27.9756 78.1988",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0649,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3114,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7709 21.5231C39.7709 26.4454 37.8155 31.1662 34.3349 34.6468C30.8542 38.1274 26.1335 40.0828 21.2112 40.0828C16.2888 40.0828 11.5681 38.1274 8.08747 34.6468C4.60685 31.1662 2.65146 26.4454 2.65146 21.5231C2.65146 16.6007 4.60685 11.88 8.08747 8.39939C11.5681 4.91877 16.2888 2.96338 21.2112 2.96338C26.1335 2.96338 30.8542 4.91877 34.3349 8.39939C37.8155 11.88 39.7709 16.6007 39.7709 21.5231Z",
    fill: "var(--warning-color, #FFC107)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8625 21.523C23.8625 22.2262 23.5832 22.9006 23.086 23.3978C22.5887 23.895 21.9144 24.1744 21.2112 24.1744C20.508 24.1744 19.8336 23.895 19.3363 23.3978C18.8391 22.9006 18.5598 22.2262 18.5598 21.523C18.5598 20.8198 18.8391 20.1454 19.3363 19.6482C19.8336 19.1509 20.508 18.8716 21.2112 18.8716C21.9144 18.8716 22.5887 19.1509 23.086 19.6482C23.5832 20.1454 23.8625 20.8198 23.8625 21.523V21.523Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2112 18.8716V9.5918",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3362 23.3979L14.5831 28.151",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomNotReady);
export default __webpack_public_path__ + "static/media/room_not_ready.0397353c.svg";
export { ForwardRef as ReactComponent };